/**
 * The types of the buttons.
 */
export const BUTTON_TYPES = {
  DESTRUCTIVE: 'destructive',
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  TERTIARY: 'tertiary'
};
export const DRAWER_MAX_HEIGHT = '80vh - 64px';

/**
 * The modes of the buttons.
 */
export const BUTTON_MODES = {
  CONTAINED: 'contained'
};

/**
 * An object containing all the class names for common CSS.
 * Add a new name here and the styles to {@code commonStyles} object.
 *
 */
export const commonClassName = {
  emptyList: 'empty-list',
  muteDialog: 'mute-dialog',
  overflowMenuItem: 'overflow-menu-item',
  overflowMenuItemIcon: 'overflow-menu-item-icon',
  participantAvatar: 'participant-avatar',
  toolboxIcon: 'toolbox-icon',
  toolboxButton: 'toolbox-button',
  toolboxContentItems: 'toolbox-content-items'
};

export const Colors = {
  green: '#00DB43',
  blue: '#10AFE2',
  white: '#FFFFFF',
  black: 'black',
  orange: '#fc7222',
  gray: '#8A9194',
  greenTransparent: '#00DB4399',
  blueTransparent: '#10AFE299',
  orangeTransparent: '#fc722299',
  redTransparent: '#FF040099',
  purpleTransparent: '#B860D599',
  lighGrayTransparant: '#dee0e399',
  lightGray: '#dee0e3',

  blackTransparent: 'rgba(0, 0, 0, 0.7)',
  whiteTransparent: 'rgba(255, 255, 255, 0.5)',
  lightGrey: '#DADADA',
  darkGrey: '#B2B2B2',
  darkGreyMore: '#4a4a4a',
  transparent: 'transparent',
  red: '#FF0400',
  grayTransparent: 'rgba(178, 179, 184, 0.5)',
  lightBlack: '#4a4a4a',
  purple: '#B860D5',
  yellow: '#FFBF00',
  pink: '#DE3163',
  mehroon: '#800000',
  fuchsia: '#FF00FF',
  navyBlue: '#000080',
  teal: '#008080',
  aqua: '#00FFFF',
  lime: '#00FF00',
  olive: '#808000'
};
export const Urls = {
  URL_LOGIN: '/api/apilogin',
  URL_SLEEP_STATUS: '/api/getOpRemote',
  URL_GET_USER_INFO: '/api/getInfo'
};
export const Events = {
  PARTICIPANTS_JOINED: 'PARTICIPANTS_JOINED',
  PARTICIPANTS_LEFT: 'PARTICIPANTS_JOINED',
  MUTE_VIDEO: 'MUTE_VIDEO',
  MESSAGE_RECEIVED: 'MESSAGE_RECEIVED',
  // electron COM Events
  CONFIGURE: 'configure',
  FETCH_DATA: 'fetchData',
  STORE_DATA: 'storeData',
  REMOVE_DATA: 'removeData',
  CONFIGURE_CAP: 'CONFIGURE',
  STORE_GET: 'STORE.GET',
  STORE_SET: 'STORE.SET',
  STORE_REMOVE: 'STORE.REMOVE'
};
export const PrivacyModes = {
  PersonalPrivacy: 'privacy',
  Sleep: 'sleep',
  External: 'external'
};
export const Labels = {
  Environment: 'appEnv',
  LoginEndPoint: 'apilogin',
  user: 'user',
  userEmail: 'userEmail',
  passwordLabel: 'Password',
  usernameLabel: 'Username',
  rememberLogin: 'rememberLogin',
  autoLogin: 'autoLogin',
  quickLogin: 'quickLogin',
  LabelRememberLogin: 'Remember Login',
  LabelAutoLogin: 'Auto Login',
  LabelQuickLogin: 'Quick Login',
  LabelClearCache: 'Clear Cache',
  LabelForgetPassword: 'Forget Password ?',
  LabelNoAccount: 'Dont have an account ? ',
  LabelCreate: 'Create',
  LabelVideoWindow: 'Video Window',
  UserInfo: 'user',
  LabelLogout: 'Logout',
  HomeRoute: 'HomeScreen',
  LoginRoute: 'LoginScreen',
  LoggedIn: 'Logged in',
  InvalidUsername: 'Please enter username',
  InvalidPassword: 'Please enter password',
  Cancel: 'Cancel',
  close: 'Close',
  save: 'Save changes',
  Ok: 'OK',
  timer: 49,
  timerStart: 'timerStart',
  VideoWindow: 'Video Window',
  FindOut: 'Find out more at',
  VideoWindowlink: 'https://www.videowindow.com',
  VideoWindowSupportLink: 'https://www.videowindow.com/support/',
  VideoWindowlink_: 'videowindow.com',
  externalCallPlaceHolderText: 'Enter Zoom ID',
  externalCalls: 'External calls - Zoom',
  camera: 'Camera',
  microphone: 'Microphone',
  playTestSound: 'Play a test sound',
  audioOut: 'Audio output',
  externalCallDetails:
    'Leave the always-on mode and make an external video call to a Zoom meeting.',
  privacyMinuts: 'Privacy (Minutes)',
  sysInfo: 'System information',
  connection: 'Connection',
  bitrate: 'Bitrate',
  packLost: 'Packet loss',
  p2p: 'P2P',
  codecs: 'codecs (A/V)',
  resolution: 'Resolution',
  frameRate: 'Frame rate',
  servCount: 'Server count',
  estimatedBand: 'Estimated bandwidth',
  remoteAddress: 'Remote address',
  localAddress: 'Local address',
  transport: 'Transport',
  connectedTo: 'Connected to',
  submit: 'Submit',
  settingDetailText:
    '(Put the video window into sleep mode for set a duration and dont worry you can always wake it again anytime with a simple tab.)',
  reconnect: 'Reconnect',
  settings: 'Settings',
  systemInformation: 'System \nInformation',
  logout: 'logout',
  muteMic: 'mute mic',
  joinAudio: 'join audio',
  joinAudioAndVideo: 'join \naudio & video',
  unMuteMic: 'un-mute mic',
  micIsOn: 'mic is on',
  micIsOff: 'mic is off',
  leaveAudio: 'leave audio',
  speakerIsOn: 'speaker is on',
  speakerIsOff: 'speaker is off',
  more: 'more',
  menu: 'menu',
  view: 'view',
  knock: 'knock',
  whiteboard: 'whiteboard',
  send: 'Send',
  emailPlacholder: 'Enter email address',
  emailInvalid: 'Please enter valid email address',
  sleepModeTextStart: 'This Video Window is in sleep mode for',
  sleepModeTextEnd: '\ntap the screen to wake up for 30 minutes',
  privacySleepModeTextEnd: '\ntap the screen to end privacy mode early.',
  privacyModeTextStart: 'This Video Window is in privacy mode for',
  externalModeTextStart: 'This Video Window is in external mode',
  externalModeTextEnd: '\ntap the screen to end external mode.',
  idleTime: 600,
  videoMutedMessage: 'Toggle video on to see their video and start your video',
  noParticipantMessage:
    'You are the only connection, please wait for another site to join, or contact your Video Window administrator for assistance.',
  connectingAudioMessage: 'We are connecting your audio, please wait',
  disconnectingAudioMessage: 'We are disconnecting your audio, please wait',
  noOneOnStage: 'No one is on stage right now.'
};
